import * as React from 'react';

export const TranslationsContext = React.createContext(
  undefined as {
    translations: any;
    setTranslations: React.Dispatch<React.SetStateAction<any>>;
  }
);
